export default function AppIcon({ src, alt, size = 56, className = "" }) {
  return (
    <div
      className={`shrink-0 overflow-hidden bg-white/5 ${className}`}
      style={{ width: size, height: size, borderRadius: size * 0.225 }}
    >
      {src ? (
        <img
          src={src}
          alt={alt}
          loading="lazy"
          className="w-full h-full object-cover"
          draggable={false}
        />
      ) : (
        <div className="w-full h-full grid place-items-center text-white/40 font-display font-bold">
          {(alt || "?").slice(0, 1)}
        </div>
      )}
    </div>
  );
}
